var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { attrs: { cols: "12", lg: "12" } },
        [
          _c(
            "Aggregate",
            _vm._b(
              {
                attrs: {
                  title: "Markets",
                  "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                    "input",
                    "market",
                  ]),
                  ItemConstructor: _vm.marketFactory,
                  headers: _vm.headers,
                  dense: "",
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change")
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.bus_id",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c("v-select", {
                          attrs: {
                            items: _vm.nodeIndex,
                            label: _vm.schema.bus_id.title,
                            "single-line": "",
                            dense: "",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$emit("change")
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function (data) {
                                  return [
                                    _vm._v(" " + _vm._s(data.item.name) + " "),
                                    _c(
                                      "span",
                                      { staticClass: "text-caption ml-2" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            "(ID: " + data.item.value + ")"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item",
                                fn: function (data) {
                                  return [
                                    _vm._v(" " + _vm._s(data.item.name) + " "),
                                    _c(
                                      "span",
                                      { staticClass: "text-caption ml-2" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            "(ID: " + data.item.value + ")"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: item.bus_id,
                            callback: function ($$v) {
                              _vm.$set(item, "bus_id", $$v)
                            },
                            expression: "item.bus_id",
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (ref) {
                      var item = ref.item
                      var errors = ref.errors
                      return [
                        _c(
                          "v-card",
                          { staticClass: "pa-2 ma-2", attrs: { flat: "" } },
                          [
                            _c(
                              "v-card-text",
                              [
                                _c(
                                  "v-card",
                                  { staticClass: "mb-6", attrs: { flat: "" } },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-subtitle-1 font-weight-bold",
                                      },
                                      [_vm._v("General")]
                                    ),
                                    _c("v-switch", {
                                      attrs: {
                                        label: _vm.schema.constant_price.title,
                                        hint: _vm.schema.constant_price.tooltip,
                                        "persistent-hint": "",
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "constant_price",
                                            "messages",
                                          ]),
                                        dense: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.constant_price,
                                        callback: function ($$v) {
                                          _vm.$set(item, "constant_price", $$v)
                                        },
                                        expression: "item.constant_price",
                                      },
                                    }),
                                    item.constant_price
                                      ? _c("InputYearly", {
                                          attrs: {
                                            label: _vm.schema.price.title,
                                            hint: _vm.schema.price.tooltip,
                                            "error-messages":
                                              _vm.$utils.getIfExists(errors, [
                                                "price",
                                                "messages",
                                              ]),
                                            suffix: _vm.schema.price.unit,
                                            type: "number",
                                            num_years: _vm.num_years,
                                            fill: "",
                                            "fill-value":
                                              _vm.schema.price.items.default,
                                            min: _vm.schema.price.items.minimum,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$emit("change")
                                            },
                                          },
                                          model: {
                                            value: item.price,
                                            callback: function ($$v) {
                                              _vm.$set(item, "price", $$v)
                                            },
                                            expression: "item.price",
                                          },
                                        })
                                      : _c("InputYearlyProfile", {
                                          attrs: {
                                            label:
                                              _vm.schema.price_profiles.title,
                                            hint: _vm.schema.price_profiles
                                              .tooltip,
                                            suffix: _vm.schema.price.unit,
                                            "error-messages":
                                              _vm.$utils.getIfExists(errors, [
                                                "price_profiles",
                                              ]),
                                            num_years: _vm.num_years,
                                            "profile-type":
                                              _vm.schema.price_profiles
                                                .profileType,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$emit("change")
                                            },
                                          },
                                          model: {
                                            value: item.price_profiles,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "price_profiles",
                                                $$v
                                              )
                                            },
                                            expression: "item.price_profiles",
                                          },
                                        }),
                                    _c("v-switch", {
                                      attrs: {
                                        label: _vm.schema.constant_buy.title,
                                        hint: _vm.schema.constant_buy.tooltip,
                                        "persistent-hint": "",
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "constant_buy",
                                            "messages",
                                          ]),
                                        dense: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.constant_buy,
                                        callback: function ($$v) {
                                          _vm.$set(item, "constant_buy", $$v)
                                        },
                                        expression: "item.constant_buy",
                                      },
                                    }),
                                    item.constant_buy
                                      ? _c("InputYearly", {
                                          attrs: {
                                            label: "Hourly Purchase Limit ",
                                            hint: _vm.schema.buy_limit.tooltip,
                                            "error-messages":
                                              _vm.$utils.getIfExists(errors, [
                                                "buy_limit",
                                                "messages",
                                              ]),
                                            suffix: _vm.schema.buy_limit.unit,
                                            type: "number",
                                            num_years: _vm.num_years,
                                            fill: "",
                                            "fill-value":
                                              _vm.schema.buy_limit.items
                                                .default,
                                            min: _vm.schema.buy_limit.items
                                              .minimum,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$emit("change")
                                            },
                                          },
                                          model: {
                                            value: item.buy_limit,
                                            callback: function ($$v) {
                                              _vm.$set(item, "buy_limit", $$v)
                                            },
                                            expression: "item.buy_limit",
                                          },
                                        })
                                      : _c("InputYearlyProfile", {
                                          attrs: {
                                            label:
                                              "Hourly Purchase Limit Profile ",
                                            hint: _vm.schema.buy_limit_profiles
                                              .tooltip,
                                            "error-messages":
                                              _vm.$utils.getIfExists(errors, [
                                                "buy_limit_profiles",
                                              ]),
                                            num_years: _vm.num_years,
                                            suffix: _vm.schema.buy_limit.unit,
                                            "profile-type":
                                              _vm.schema.buy_limit_profiles
                                                .profileType,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$emit("change")
                                            },
                                          },
                                          model: {
                                            value: item.buy_limit_profiles,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "buy_limit_profiles",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.buy_limit_profiles",
                                          },
                                        }),
                                    _c("v-switch", {
                                      attrs: {
                                        label: "Constant Sale Limit",
                                        hint: _vm.schema.constant_sell.tooltip,
                                        "persistent-hint": "",
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "constant_sell",
                                            "messages",
                                          ]),
                                        dense: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.constant_sell,
                                        callback: function ($$v) {
                                          _vm.$set(item, "constant_sell", $$v)
                                        },
                                        expression: "item.constant_sell",
                                      },
                                    }),
                                    item.constant_sell
                                      ? _c("InputYearly", {
                                          attrs: {
                                            label: "Hourly Sale Limit",
                                            hint: _vm.schema.sell_limit.tooltip,
                                            "error-messages":
                                              _vm.$utils.getIfExists(errors, [
                                                "sell_limit",
                                                "messages",
                                              ]),
                                            suffix: _vm.schema.sell_limit.unit,
                                            type: "number",
                                            num_years: _vm.num_years,
                                            fill: "",
                                            "fill-value":
                                              _vm.schema.sell_limit.items
                                                .default,
                                            min: _vm.schema.sell_limit.items
                                              .minimum,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$emit("change")
                                            },
                                          },
                                          model: {
                                            value: item.sell_limit,
                                            callback: function ($$v) {
                                              _vm.$set(item, "sell_limit", $$v)
                                            },
                                            expression: "item.sell_limit",
                                          },
                                        })
                                      : _c("InputYearlyProfile", {
                                          attrs: {
                                            label: "Hourly Sale Limit Profile",
                                            hint: _vm.schema.sell_limit_profiles
                                              .tooltip,
                                            suffix: _vm.schema.sell_limit.unit,
                                            "error-messages":
                                              _vm.$utils.getIfExists(errors, [
                                                "sell_limit_profiles",
                                              ]),
                                            num_years: _vm.num_years,
                                            "profile-type":
                                              _vm.schema.sell_limit_profiles
                                                .profileType,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$emit("change")
                                            },
                                          },
                                          model: {
                                            value: item.sell_limit_profiles,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "sell_limit_profiles",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.sell_limit_profiles",
                                          },
                                        }),
                                    _c("InputYearly", {
                                      attrs: {
                                        label: "Net Sales Limits",
                                        hint: _vm.schema.net_sell_limits
                                          .tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "net_sell_limits",
                                            "messages",
                                          ]),
                                        suffix: _vm.schema.net_sell_limits.unit,
                                        type: "number",
                                        num_years: _vm.num_years,
                                        fill: "",
                                        "fill-value":
                                          _vm.schema.net_sell_limits.items
                                            .default,
                                        min: _vm.schema.net_sell_limits.items
                                          .minimum,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.net_sell_limits,
                                        callback: function ($$v) {
                                          _vm.$set(item, "net_sell_limits", $$v)
                                        },
                                        expression: "item.net_sell_limits",
                                      },
                                    }),
                                    _c("InputYearly", {
                                      attrs: {
                                        label: "Net Purchases Limits",
                                        hint: _vm.schema.net_buy_limits.tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "net_buy_limits",
                                            "messages",
                                          ]),
                                        suffix: _vm.schema.net_buy_limits.unit,
                                        type: "number",
                                        num_years: _vm.num_years,
                                        fill: "",
                                        "fill-value":
                                          _vm.schema.net_buy_limits.items
                                            .default,
                                        min: _vm.schema.net_buy_limits.items
                                          .minimum,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.net_buy_limits,
                                        callback: function ($$v) {
                                          _vm.$set(item, "net_buy_limits", $$v)
                                        },
                                        expression: "item.net_buy_limits",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      attrs: {
                                        label: _vm.schema.firm_capacity.title,
                                        hint: _vm.schema.firm_capacity.tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "firm_capacity",
                                            "messages",
                                          ]),
                                        suffix: _vm.schema.firm_capacity.unit,
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.firm_capacity,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "firm_capacity",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.firm_capacity",
                                      },
                                    }),
                                    _c("v-switch", {
                                      attrs: {
                                        label: "Power Purchase Agreement",
                                        hint: "A price for inputs and exports",
                                        "persistent-hint": "",
                                        dense: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.ppa.active,
                                        callback: function ($$v) {
                                          _vm.$set(item.ppa, "active", $$v)
                                        },
                                        expression: "item.ppa.active",
                                      },
                                    }),
                                    item.ppa.active
                                      ? _c("InputYearlyProfile", {
                                          attrs: {
                                            "object-value": "",
                                            fill: "",
                                            "toggle-items-type": "",
                                            label: "imports PPA price",
                                            suffix: "$/MWh",
                                            num_years: _vm.num_years,
                                            "profile-type": "PPA_ENERGY_PRICE",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$emit("change")
                                            },
                                          },
                                          model: {
                                            value: item.ppa.imports,
                                            callback: function ($$v) {
                                              _vm.$set(item.ppa, "imports", $$v)
                                            },
                                            expression: "item.ppa.imports",
                                          },
                                        })
                                      : _vm._e(),
                                    item.ppa.active
                                      ? _c("InputYearlyProfile", {
                                          attrs: {
                                            "object-value": "",
                                            fill: "",
                                            "toggle-items-type": "",
                                            label: "exports PPA price",
                                            suffix: "$/MWh",
                                            num_years: _vm.num_years,
                                            "profile-type": "PPA_ENERGY_PRICE",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$emit("change")
                                            },
                                          },
                                          model: {
                                            value: item.ppa.exports,
                                            callback: function ($$v) {
                                              _vm.$set(item.ppa, "exports", $$v)
                                            },
                                            expression: "item.ppa.exports",
                                          },
                                        })
                                      : _vm._e(),
                                    _c("v-divider", { staticClass: "mt-4" }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-card",
                                  { staticClass: "mb-6", attrs: { flat: "" } },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-subtitle-1 font-weight-bold",
                                      },
                                      [_vm._v("Power Flow Parameters")]
                                    ),
                                    _c("v-switch", {
                                      attrs: {
                                        label: _vm.schema.active.title,
                                        dense: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.active,
                                        callback: function ($$v) {
                                          _vm.$set(item, "active", $$v)
                                        },
                                        expression: "item.active",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      attrs: {
                                        label:
                                          _vm.schema.voltage_set_point.title,
                                        suffix:
                                          _vm.schema.voltage_set_point.unit,
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.voltage_set_point,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "voltage_set_point",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.voltage_set_point",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      attrs: {
                                        label: _vm.schema.angle_set_point.title,
                                        suffix: _vm.schema.angle_set_point.unit,
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.angle_set_point,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "angle_set_point",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.angle_set_point",
                                      },
                                    }),
                                    _c("v-divider", { staticClass: "mt-4" }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-card",
                                  { staticClass: "mb-6", attrs: { flat: "" } },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-subtitle-1 font-weight-bold",
                                      },
                                      [_vm._v("Short Circuit Parameters")]
                                    ),
                                    _c("InputTextField", {
                                      attrs: {
                                        label:
                                          _vm.schema.max_SC_power_provision
                                            .title,
                                        suffix:
                                          _vm.schema.max_SC_power_provision
                                            .unit,
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.max_SC_power_provision,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "max_SC_power_provision",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression:
                                          "item.max_SC_power_provision",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      attrs: {
                                        label:
                                          _vm.schema.min_SC_power_provision
                                            .title,
                                        suffix:
                                          _vm.schema.min_SC_power_provision
                                            .unit,
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.min_SC_power_provision,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "min_SC_power_provision",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression:
                                          "item.min_SC_power_provision",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      attrs: {
                                        label:
                                          _vm.schema.max_SC_impedance_rx_ratio
                                            .title,
                                        suffix:
                                          _vm.schema.max_SC_impedance_rx_ratio
                                            .unit,
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.max_SC_impedance_rx_ratio,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "max_SC_impedance_rx_ratio",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression:
                                          "item.max_SC_impedance_rx_ratio",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      attrs: {
                                        label:
                                          _vm.schema.min_SC_impedance_rx_ratio
                                            .title,
                                        suffix:
                                          _vm.schema.min_SC_impedance_rx_ratio
                                            .unit,
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.min_SC_impedance_rx_ratio,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "min_SC_impedance_rx_ratio",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression:
                                          "item.min_SC_impedance_rx_ratio",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.computedInput.markets,
                  callback: function ($$v) {
                    _vm.$set(_vm.computedInput, "markets", $$v)
                  },
                  expression: "computedInput.markets",
                },
              },
              "Aggregate",
              _vm.$attrs,
              false
            )
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }